<template>
  <div>
    <h3>{{ item.proTableNo }}</h3>
    <div class="list">
      <div class="item full">
        <span class="label">收货地址：</span>
        <span class="value">{{ item.shipAddr }}</span>
      </div>
      <div class="item">
        <span class="value">{{ item.shipPerson }} {{ item.shipMobile }}</span>
      </div>
      <div class="item">
        <div class="value" style="text-align: right;">
          {{ item.trackCompany }}
          <a href="javascript:" @click="trackVisible = true">{{
            item.trackNum
          }}</a>
        </div>
      </div>
    </div>
    <el-table :data="item.packList" style="width: 100%">
      <div class="no_show_message" slot="empty">
        <img src="@/assets/img/good/noGood.png" alt="暂无数据" />
        <div>暂无数据</div>
      </div>
      <el-table-column prop="productName" label="物品名称"> </el-table-column>
      <el-table-column prop="freeparamb" label="配置" width="180px">
      </el-table-column>
      <el-table-column prop="quantity" label="数量" width="80px">
      </el-table-column>
      <el-table-column prop="unit" label="单位" width="80px"></el-table-column>
    </el-table>
    <div class="tip">
      <a href="javascript:" v-if="item.packTotal > 5" @click="moreVisible = true">查看更多物品</a>
      <span></span>
      <span
        ><i class="el-icon-warning-outline"></i
        >物品可能会根据情况做协商调整，具体以验收为准</span
      >
    </div>
    <el-dialog title="查看轨迹" :visible.sync="trackVisible" width="667px">
      <ViewTrack v-if="trackVisible" :deliveryId="item.deliveryId"></ViewTrack>
    </el-dialog>
    <el-dialog title="全部物品" :visible.sync="moreVisible" width="800px">
      <PackList v-if="moreVisible" :proTableNo="item.proTableNo"></PackList>
    </el-dialog>
  </div>
</template>

<script>
import ViewTrack from './view-track.vue'
import PackList from './packList.vue'
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ViewTrack,
    PackList
  },
  data () {
    return {
      trackVisible: false,
      moreVisible: false
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  display: flex;
  flex-wrap: wrap;
  line-height: 28px;
  padding-bottom: 12px;
  .item {
    width: 50%;
    .label {
      color: #666;
    }
    .value {
      color: #333;
    }
    &.full {
      width: 100%;
    }
  }
}
.tip {
  display: flex;
  justify-content: space-between;
  color: #666;
  padding-top: 8px;
  i {
    margin-right: 4px;
  }
}
</style>
